<template>
  <iframe v-if="marcador" :src="'https://maps.google.com/maps?q='+marcador.latitud + ', '+ marcador.longitud +'&z=15&output=embed'"
           frameborder="0"
          style="border:0; width:100%; height: 30vh;"></iframe>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {Inmueble} from "@/Modelos/Inmueble";
import {namespace} from "vuex-class";
const WidgetMapStore = namespace('WidgetMapStore');
@Component({})
export default class GoogleMaps extends Vue {

  @WidgetMapStore.State
  private inmuebles!:Array<Inmueble>;



  get marcador()
  {
    if(this.inmuebles && this.inmuebles.length > 1) {

      const cadorDestacado = this.inmuebles.filter((marcador:Inmueble) => {
        if(marcador.destacado) {
          return true;
        }
        return false;
      });

      const NUMERO_MINIMO_MARCADORES = 1;
      if(cadorDestacado.length < NUMERO_MINIMO_MARCADORES) {
        return this.inmuebles[0];
      }
      return cadorDestacado[0];
    }
    return null;
  }

}
</script>
